export default {
  "content": "<path d=\"M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20-8.954 20-20 20S0 31.046 0 20z\" fill=\"#000\" fill-opacity=\".05\"/><path d=\"M30 18l-1.18-6H11.18l-1.16 5.8-.02.2c0 1.47.81 2.75 2 3.44V28h10v-6.56c.38-.22.71-.5 1-.83.73.84 1.8 1.38 3 1.38v6h2v-6.56c1.19-.68 2-1.96 2-3.43zm-2.82-4l.4 2H12.42l.4-2h14.36zM12 18.09l.02-.09H16c0 1.1-.9 2-2 2-1.07 0-1.95-.85-2-1.91zM20 26h-6v-4c1.2 0 2.27-.54 3-1.38.73.84 1.8 1.38 3 1.38v4zm0-6c-1.1 0-2-.9-2-2h4c0 1.1-.9 2-2 2zm4-2h3.98l.02.09A2.009 2.009 0 0126 20c-1.1 0-2-.9-2-2z\" fill=\"#000\" fill-opacity=\".9\"/>",
  "attrs": {
    "width": "40",
    "height": "40",
    "viewBox": "0 0 40 40",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};